import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
  PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import API from "../API/urlConstants";
import { CircularProgress } from "@mui/material";
export default function CheckoutForm({ clientSecret, amount, userDetails , paymentMethod}) {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [isPaymentRequestSupported, setIsPaymentRequestSupported] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);
  // ✅ Initialize Payment Request
  useEffect(() => {
    if (!stripe || !clientSecret) return;
//     const initializePaymentRequest = async () => {
//       const pr = stripe.paymentRequest({
//         country: "US",
//         currency: "usd",
//         total: {
//           label: "Total Amount",
//           amount: Math.round(amount * 100),
//         },
//         requestPayerName: true,
//         requestPayerEmail: true,
//         supportedPaymentMethods: [
//           {
//             supportedMethods: "apple-pay",
//             data: {
//               merchantIdentifier: "merchant.com.user.grati.community",
//               supportedNetworks: ["visa", "mastercard", "amex"],
//               countryCode: "US",
//               currencyCode: "usd",
//             },
//           },
//           {
//             supportedMethods: "google-pay",
//             data: {
//               environment: "TEST",
//               apiVersion: 2,
//               apiVersionMinor: 0,
//               merchantInfo: {
//                 merchantName: "Grati, LLC",
//                 merchantId: "BCR2DN4TQPP5TEQW",
//               },
//               allowedPaymentMethods: [
//                 {
//                   type: "CARD",
//                   parameters: {
//                     allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
//                     allowedCardNetworks: ["VISA", "MASTERCARD"],
//                   },
//                   tokenizationSpecification: {
//                     type: "PAYMENT_GATEWAY",
//                     parameters: {
//                       gateway: "stripe",
//                       "stripe:version": "2020-08-27",
//                     },
//                   },
//                 },
//               ],
//             },
//           },
//         ],
//       });
// console.log(pr, "paymentRequest")
//       const result = await pr.canMakePayment();
//       if (result) {
//         setPaymentRequest(pr);
//         setIsPaymentRequestSupported(true);
//       } else {
//         setIsPaymentRequestSupported(false);
//       }
//     };
//     initializePaymentRequest();
  }, []);
  // ✅ Handle Card Payment Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      setMessage("Stripe is not initialized.");
      return;
    }
    setIsLoading(true);
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${API.WEB_STAGING_URL}/${userDetails?._id || localStorage.getItem("userid")}`,
      },
    });
    if (error) {
      setMessage(error.message);
    }
    setIsLoading(false);
  };
  const paymentElementOptions = { layout: "tabs" };
  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {/* ✅ Show Apple Pay / Google Pay Button if Supported */}
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      {/* ✅ Show Pay Now Button for Card Payments */}
      {!isPaymentRequestSupported && (
        <button
          disabled={isLoading || !stripe || !elements}
          id="submit"
          className="flex justify-center bg-[#FF6F29] w-full h-[3rem] rounded-[0.625rem] items-center mt-4"
        >
          {isLoading ? (
            <CircularProgress size="20px" style={{ color: "white" }} />
          ) : (
            <p className="text-white font-bold text-lg">Pay Now</p>
          )}
        </button>
      )}
      {/* ✅ Error Message */}
      {message && (
        <div id="payment-message" className="text-red-500 text-left pt-2 text-sm">
          {message}
        </div>
      )}
    </form>
  );
}
/**
 import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
  PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import API from "../API/urlConstants";
import { CircularProgress, Skeleton } from "@mui/material";
export default function CheckoutForm({ clientSecret, amount, paymentMethod, isCircularLoading, setIsCircularLoading , userDetails}) {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
    if (!stripe || !clientSecret) {
      return;
    }
    const paymentRequest = stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: "Total Amount",
        amount: Math.round(amount * 100), 
      },
      requestPayerName: true,
      requestPayerEmail: true,
      supportedPaymentMethods: [
        {
          supportedMethods: "google-pay",
          data: {
            environment: "TEST", 
            apiVersion: 2,
            apiVersionMinor: 0,
            merchantInfo: {
              merchantName: "Grati, LLC", 
              merchantId: "BCR2DN4TQPP5TEQW", 
            },
            allowedPaymentMethods: [
              {
                type: "CARD",
                parameters: {
                  allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                  allowedCardNetworks: ["VISA", "MASTERCARD"],
                },
                tokenizationSpecification: {
                  type: "PAYMENT_GATEWAY",
                  parameters: {
                    gateway: "stripe",
                    "stripe:version": "2020-08-27",
                  },
                },
              },
            ],
          },
        },
        {
          supportedMethods: "apple-pay",
          data: {
            merchantIdentifier: "merchant.com.user.grati.community", 
            supportedNetworks: ["visa", "mastercard", "amex"], 
            countryCode: "US", 
            currencyCode: "usd", 
            total: {
              label: "Total Amount",
              amount: Math.round(amount * 100), 
            },
          },
        },
      ],
    });
    console.log({paymentRequest})
    paymentRequest.canMakePayment().then((result) => {
      if (result) {
        console.log(result, "result")
        setIsCircularLoading(false);
        if (
          (paymentRequest && paymentMethod === "google_pay" && result.googlePay) ||
          (paymentRequest && paymentMethod === "apple_pay" && result.applePay)
        ) {
          paymentRequest.show();
        
        }
        setMessage(
          paymentMethod === "google_pay" && !result.googlePay
            ? "Google Pay is not supported."
            : paymentMethod === "apple_pay" && !result.applePay
            ? "Apple Pay is not supported."
            : ""
        );
      }
      
    });
    paymentRequest.on("paymentmethod", async (event) => {
      try {
       
        const { error } = await stripe.confirmPayment({
          payment_method: event.paymentMethod.id,
          clientSecret,
        });
    
        if (error) {
          event.complete("fail");
          setMessage(error.message || "Payment failed. Please try again.");
        } else {
          event.complete("success");
    
        
          const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
    
          if (paymentIntent) {
            switch (paymentIntent.status) {
              case "succeeded":
                setMessage("Payment succeeded!");
               if((paymentMethod === "google_pay" || paymentMethod === "apple_pay")) handleSubmit()
                break;
              case "processing":
                setMessage("Your payment is processing.");
                break;
              case "requires_payment_method":
                setMessage("Your payment was not successful, please try again.");
                break;
              default:
                setMessage("Something went wrong.");
                break;
            }
          }
        }
      } catch (err) {
        event.complete("fail");
        setMessage("Payment canceled or failed. Please try again.");
      }
    });
    
  }, [stripe, clientSecret, amount]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      setMessage("Stripe is not initialized.");
      return;
    }
    setIsLoading(true);
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${API.WEB_PROD_URL}/${userDetails?._id || localStorage.getItem("userid")}`, 
      },
    });
    if (error) {
      setMessage(error.message);
    }
    setIsLoading(false);
  };
  const paymentElementOptions = {
    layout: "tabs",
  };
  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {paymentMethod !== "google_pay" && paymentMethod !== "apple_pay" && (
        <PaymentElement id="payment-element" options={paymentElementOptions} />
      )}
      {isCircularLoading &&
        (paymentMethod === "google_pay" || paymentMethod === "apple_pay") && (
          <div className="flex items-center justify-center mt-4">
            <CircularProgress size="30px" style={{ color: "#FF8245" }} />
            <span class="mx-4 inline-block animate-pulse transform transition-transform duration-1000 text-[#FF8245] font-semibold text-xs ease-in-out scale-100 hover:scale-110">
              Loading Wallet...
            </span>
          </div>
        )}
     {  (paymentMethod === "google_pay" || paymentMethod === "apple_pay")? null: <button
        disabled={isLoading || !stripe || !elements}
        id="submit"
        className="flex justify-center bg-[#FF6F29] w-full h-[3rem] rounded-[0.625rem] items-center mt-4"
      >
        <span id="button-text">
          {isLoading ? (
            <div className="spinner" />
          ) : (
            <p className="text-white font-bold text-lg">Pay Now</p>
          )}
        </span>
      </button>}
      {message && (
        <div
          id="payment-message"
          class="text-red-500 text-left pt-2 text-sm pt-[10px]" 
        >
          {message}
        </div>
      )}
    </form>
  );
}
/**import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
  PaymentRequestButtonElement
} from "@stripe/react-stripe-js";
import API from "../API/urlConstants";
export default function CheckoutForm({key,amount}) {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [applePaySupported, setApplePaySupported] = useState(false);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [applePayTest, setApplePayTest] = useState("");
  useEffect(() => {
    if (!stripe) {
      return;
    }
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
console.log({clientSecret})
    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then((response) => {
console.log(response, "response")
      switch (response.status) {
        case "succeeded":
         setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
    
    
      // Create a payment request for Apple Pay
      const paymentRequest = stripe.paymentRequest({
        country: "US", // Adjust to your country
        currency: "usd", // Adjust to your currency
        total: {
          label: "Total Amount",
          amount: 1000, // Replace with the correct amount in cents
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });
      setApplePayTest(paymentRequest)
      // Check if Apple Pay is available
      paymentRequest.canMakePayment({ applePay: true }).then((result) => {
        alert(result.applePay,result)
        {console.log(result, "resut")}
        if (result && result.applePay) {
        
          setPaymentRequest(paymentRequest);
          setApplePaySupported(true); // Apple Pay is available
        } else {
          setApplePaySupported(false); // Apple Pay is not available
        }
      }).catch((error)=>{console.log(error)
        setApplePayTest(error)
        alert(error)
      })
   
      paymentRequest.on("paymentmethod", async (event) => {
        const { error } = await stripe.confirmPayment(
          key, 
          {
            payment_method: event.paymentMethod.id,
          },
        
        );
    
        if (error) {
          event.complete("fail");
          alert(error.message)
          setMessage(error.message);
        } else {
          event.complete("success");
          setMessage("Payment succeeded!");
          // Optionally navigate to the success page here
        }
      
    })
    
  }, [stripe]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setIsLoading(true);
    const IdVal = localStorage.getItem("userid");
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${API.WEB_STAGING_URL}/${IdVal}`,
      },
    });
    
    if (error.type === "card_error" || error.type === "validation_error"||error.code==="card_declined") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }
    setIsLoading(false);
  };
  const paymentElementOptions = {
    layout: "tabs",
  };
console.log({paymentRequest})
  return (
    <form id="payment-form" onSubmit={handleSubmit}>
          <div>{applePayTest}</div>
      {applePaySupported && (
        <PaymentRequestButtonElement options={{ paymentRequest }} />
      )}  
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      {amount>0 && (
      <button
        disabled={isLoading || !stripe || !elements}
        id="submit"
        className="flex flex justify-center bg-[#FF6F29] w-full h-[3rem]  rounded-[0.625rem] items-center  mt-4 ">
        <span id="button-text">
          {isLoading ? (
            <div class="grid min-h-[140px] w-full place-items-center rounded-lg p-6 ">
              <svg class="text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24">
                <path
                  d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                  stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                <path
                  d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                  stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-200">
                </path>
              </svg>
            </div>) : (
            <p className="text-white font-bold text-lg">Pay Now</p>
          )}
        </span>
      </button>)}
      {message && <div id="payment-message" style={{color:"red",textAlign:"left",paddingTop:"10px"}}>{message}</div>}
    </form>
  );
}

 **/